<template>
  <div>
    <headerNav title="收支明细" />
    <div>
      <van-tabs v-model="tabCurrentIndex" @change="tabchange" sticky>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-tab :title="navitem.text" v-for="(navitem,navindex) in navList" :key="navindex">
            <van-list
              v-model="navitem.loaded"
              :finished="navitem.loadingType=='nomore'?true:false"
              :finished-text="navitem.loadingType=='nomore'?'没有更多了':'下拉加载更多'"
              @load="loadData"
            >
              <div v-for="(item,index) in navitem.List" class="mian-list" :key="index">
                
                <div class="mian-list-info">
                     <div class="mian-list-info-data">
                        <span>类型:</span>
                        <span>{{item.tranferCostTypeEnumName}}({{item.isToCompony?'转公司':'自发'}})</span>
                         <van-tag type="primary" class="mian-list-info-right-tag" v-if="item.state==1" size="medium">冻结</van-tag>
                        <van-tag type="danger" class="mian-list-info-right-tag" v-if="item.state==2" size="medium">失败</van-tag>
                        <van-tag type="success" class="mian-list-info-right-tag" v-if="item.state==0" size="medium">成功</van-tag>
                    </div>
                     <div class="mian-list-info-data">
                        <span>单号:</span>
                        <span>{{item.tid||item.cloundWithdrawNo}}</span>
                    </div>
                    <div class="mian-list-info-data">
                        <span>金额:{{item.totalMoney}}<span v-if="item.postFee>0">(含运费{{item.postFee}})</span></span>
                    </div>
                    <div class="mian-list-info-data" v-if="item.subDealerName">
                        <span>下级:{{item.subDealerName}}</span>
                    </div>
                    <div class="mian-list-info-data-last">
                        {{item.creationTime}}
                    </div>
                </div>         
<!-- 
                <div class="mian-list-mark" v-if="item.comment">
                  <div>备注:{{item.comment}}</div>
                </div> -->
              </div>
            </van-list>
          </van-tab>
        </van-pull-refresh>
      </van-tabs>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      date: "",
      show: false,
      tabCurrentIndex: 0,
      navList: [
        {
          state:0,
          text: "全部",
          loadingType: "more",
          loaded: false,
          getparams: {
            sorting: "",
            maxResultCount: 10,
            skipCount: 0,
          },
          List: [],
        },
        {
          state:1,
          text: "收入",
          loadingType: "more",
          loaded: false,
          getparams: {
            state: 0,
            sorting: "",
            maxResultCount: 10,
            skipCount: 0,
          },
          List: [],
        },
        {
          state:2,
          text: "支出",
          loadingType: "more",
          loaded: false,
          getparams: {
            state: 1,
            sorting: "",
            maxResultCount: 10,
            skipCount: 0,
          },
          List: [],
        },
        {
          state: 3,
          text: "冻结",
          loadingType: "more",
          loaded: false,
          getparams: {
            state: 2,
            sorting: "",
            maxResultCount: 10,
            skipCount: 0,
          },
          List: [],
        },
        {
          state: 4,
          text: "失败",
          loadingType: "more",
          loaded: false,
          getparams: {
            state: 3,
            sorting: "",
            maxResultCount: 10,
            skipCount: 0,
          },
          List: [],
        }
      ],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageParams: {
        maxResultCount: 8,
        skipCount: 0,
      },
      totalCount: 0,
    };
  },
  created() {
    var option = this.$route.query;

    if (option.state) {
        this.tabCurrentIndex = Number.parseInt(option.state);
    }
     this.loadData();
  },
  methods: {
    formatDate(date) {
      return `${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      const [start, end] = date;
      this.show = false;
      this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
    },
    tabchange() {
      this.loadData("tabChange");
    },
    onRefresh() {

      this.loadData("refresh");
    },
    loadData(source) {
      let index = this.tabCurrentIndex;
      let navItem = this.navList[index];
      // let state = navItem.state;

      if (source === "tabChange" && navItem.loaded === true) {
        //tab切换只有第一次需要加载数据
        return;
      }
      if (
        navItem.loadingType === "loading" ||
        navItem.loadingType === "nomore"
      ) {
        //防止重复加载
        if(source!="refresh")
        {
          return;
        }
      }
      if (source == "refresh"||navItem.loadingType=='refresh') {
        this.navList[index].List = [];
        this.navList[index].getparams.skipCount = 0;
      }
      navItem.loadingType = "loading";
      var params = navItem.getparams;
      //加载数据
      this.ajax
        .post("/api/services/app/PhoneClound/QueryCostLog", params)
        .then((x) => {
          this.navList[index].getparams.skipCount += this.navList[
            index
          ].getparams.maxResultCount;
          let totalcount = x.result.totalCount;
          this.navList[index].List = this.navList[index].List.concat(
            x.result.items
          );
          //console.log(this.navList);
          // item = Object.assign(item, this.orderStateExp(item.state));
          this.navList[index].loadingType =
            totalcount > this.navList[index].getparams.skipCount
              ? "more"
              : "nomore";
        })
        .finally(() => {
          this.$set(this.navList[index], "loaded", false);
          this.refreshing=false;
        });
    },
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
        this.pageParams.skipCount = 0;
      }

      this.ajax
        .post(
          "/api/services/app/PhoneWallet/QueryMyRechargeRecords",
          this.pageParams
        )
        .then((x) => {
          const items = x.result.items;
          this.list.push(...x.result.items);
          this.pageParams.skipCount += this.pageParams.maxResultCount;
          this.totalCount = x.result.totalCount;
        })
        .finally(() => {
          this.loading = false;

          if (this.pageParams.skipCount >= this.totalCount) {
            this.finished = true;
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.mian-list{
  background-color: #fff;
  margin-top: 10px;
  font-size: 12px;
  border-radius: 8px;
  margin: 10px;
  padding: 10px;
  box-shadow: 1px 1px 4px #c3c3c3;
  word-break: break-all;
  line-height: 20px;
}
.mian-list-info{
  padding: 5px 0 5px 0px;
  font-size: 14px;
  position: relative;
  word-break: break-all;
}
.mian-list-info-right{
  position: absolute;
  right: 0;
  width: 90px;
  text-align: right;
}
.mian-list-info-right-tag{
  position: absolute;
  right: 0;
}
.mian-list-mark{
  border-top: 1px solid #e2e2e2;
  padding-top: 10px;
  font-size: 18px;
}
.mian-list-btns{
  margin-top: 20px;
  text-align: center;
}
.mian-list-btns button{
    margin-right: 10px;
    padding: 8px 20px;
    height: auto;
    border-radius: 34px;
    border: 0;
}
.mian-list-pic{
  position: absolute;
  top: 50%;
  left:0;
  width: 100px;
  height: 100px;
  transform: translate(0,-50%);
}
.mian-list-pic img{
  width: 100%;
  height: 100%;
}
.info{
    position: relative;
    background-color: #fff;
    border-radius: 8px;
    margin: 20px 10px 10px 10px;
    font-size: 12px;
    width: 250px;
}
.mz-proof-btns{
  margin-bottom: 10px;
  text-align: center;
}
.mz-proof-btns button{
  margin-right: 10px;
  padding: 8px 20px;
  height: auto;
  border-radius: 34px;
  border: 0;
}
.mian-list-info-data-last{
  text-align: right;
}
.van-uploader__wrapper{
    width: 100%;
    display: block;
  }
  
  .van-uploader__upload{
    width: 100%;
  }
  .van-uploader{
    display: block;
  }
  .van-uploader__preview-image{
    width: 100%;
    height: 80px;
  }
</style>
